import React from "react";
import Container from "react-bootstrap/Container"

function ProcessoSeletivo() {

	return (
		<Container className="mt-5">
			<div className="row g-3 justify-content-center  mb-5">
				<div className="col-md-8  mt-3" style={{ textAlign: 'center' }}>
					{/* <h2>Inscrições</h2> */}

					<h2> Em breve inscrições para Turma 4!!!</h2>
					<img src="assets/img/ampulheta.gif" alt="https://icons8.com/icon/TmIKpxTOSBi7/hourglass" />

					{/* <p> Agosto de 2024 </p> */}

					{/* <p style={{ fontSize: '20px' }}>O processo seletivo para admissão de alunos para a <b>Turma 3</b> é regido pelo edital disponível abaixo:</p>
					<ul>
						<li style={{ fontSize: '20px', marginBottom: '15px' }}>
							<a target="_blank" rel="noopener noreferrer" href="files/edital_001_2024.pdf" >Edital 001/2024 - Seleção de Discentes</a>
						</li>

						<p style={{ fontSize: '20px' }}>O período de inscrição para o processo seletivo será de <strong>02/01/2024</strong> a <strong>12/01/2024</strong>.</p>

						<li style={{ fontSize: '20px', marginBottom: '15px' }}>
							<a target="_blank" rel="noopener noreferrer" href="files/homologacao_inscricoes_edital_001_2024.pdf" >Resultado da Homologação das Inscrições</a>
						</li>
						<li style={{ fontSize: '20px', marginBottom: '15px' }}>
							<a target="_blank" rel="noopener noreferrer" href="files/Edital 001_2024_Resultado_Final_Preliminar.pdf" >Resultado Final Preliminar da Homologação das Inscrições</a>
						</li>
						<li style={{ fontSize: '20px' }}>
							<a target="_blank" rel="noopener noreferrer" href="files/Edital_001_2024_-_Resultado_Final.pdf" >Resultado Final</a>
						</li> */}
					{/* <li>
							<a target="_blank" rel="noopener noreferrer" href="files/errata_edital_002_2023.pdf">Errata - Edital 002/2023</a>
						</li>
						<li>
							<a target="_blank" rel="noopener noreferrer" href="files/errata2_edital_002_2023.pdf" >Errata 2 - Edital 002/2023</a>
						</li>
						<li>
							<a target="_blank" rel="noopener noreferrer" href="files/homologacao_inscricoes_edital_002_2023.pdf" >Resultado da Homologação das Inscrições</a>
						</li>
						<li>
							<a target="_blank" rel="noopener noreferrer" href="files/errata_homologacao_inscricoes_edital_002_2023.pdf" >Errata - Resultado da Homologação das Inscrições</a>
						</li> */}


					{/* </ul> */}


					{/* <p style={{ fontSize:'20px' }}>As inscrições serão efetuadas exclusivamente de forma on-line, através do <a target="_blank" rel="noopener noreferrer" href="https://forms.gle/dnehp72u7TnY9zDG8"> Requerimento
						de Inscrição</a>.</p> */}


					{/* <hr className="m-5" /> */}
				</div>
			</div>

			{/* <div className="row g-3 justify-content-center">
				<div className="col-md-8">
					<h3>Resultado</h3>
					<ul>
						<li>
							<a target="_blank" rel="noopener noreferrer" href="files/resultado_edital_002_2023.pdf" >Resultado Preliminar - Edital 002/2023</a>
						</li>
						<li>
							<a target="_blank" rel="noopener noreferrer" href="files/resultado_final_edital_002_2023.pdf" >Resultado Final - Edital 002/2023</a>
						</li>	
					</ul>

				</div>
			</div> */}
		</Container >
	)
}

export default ProcessoSeletivo